import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Accordion from "../shared/Accordion";

export default function FAQ() {
  const location = useLocation();

  const questions = [
    {
      title: "I did not receive my order, what do I do now?",
      description: ` <div>
          <p>
            Please ensure the following criteria are met before placing an order to secure a
            successful delivery.
          </p>
          <p>
            Make sure you are following the process and the following criteria are met before you
            place your order.
          </p>
          <ul>
            <li>Set your Instagram to public</li>
            <li>Make sure that you have typed the correct Instagram username</li>
            <li>Do not change your Instagram username before the order is complete</li>
            <li>Make sure the account or the post still exists and has not been deleted</li>
            <li>The video follows Instagram’s guidelines and has not been restricted or removed</li>
            <li>Make sure that 24 hours have passed for the completion of order delivery</li>
          </ul>
          <p>
            If you still experience issues after this with the order delivery, please do not
            hesitate to contact our support team.
          </p>
        </div>`,
    },
    {
      title: "Why am I seeing a drop in my followers?",
      description:
        "Not likely but it can happen that but it might happen that occasionally Instagram will delete accounts that users mark as spam. This can cause the follower to drop, and sometimes it can impact our customers, and sometimes it doesn’t. ",
    },
    {
      title: "Can I remove the followers I ordered and received?",
      description: ` <div>
          Due to all followers being real from genuine Instagram accounts, we cannot remove them.
          You may remove them manually from your follower list one by one. All followers delivered
          are real from genuine Instagram accounts. Due to this benefit our team cannot transfer or
          remove followers once they are delivered.
        </div>`,
    },
    {
      title: "How do I stop follower refill?",
      description: "You can do so by simply sending an email to our support team. ",
    },
    {
      title: "How many followers can I order?",
      description:
        "You can buy as many times as you need as long as your orders do not go more than 1000,000 followers within a 30-day time frame.",
    },
    {
      title: "How many likes can I order?",
      description:
        "You can buy as many times as you need as long as your orders do not go more than 1000,000 likes within a 30-day time frame.",
    },
    {
      title: "What is the refund policy?",
      description:
        "If there are issues with the delivery, please contact our customer support within the first 30 days from the date of the initial purchase. We’ll do our best to make sure the issue is resolved.",
    },
    {
      title: "My credit card was declined, what can I do?",
      description:
        "When a credit card is declined, our leading recommendation is to contact your bank for more assistance as they may have more insight into what may be causing the issue.",
    },
  ];

  return (
    <section className="my-20">
      {location.pathname === "/faq" ? (
        <Helmet>
          <title>Dailysocialboost | FAQ</title>
        </Helmet>
      ) : null}
      <h2 className="text-center text-5xl font-bold my-10">Frequently Asked Questions</h2>
      <div>
        {questions.map((question, idx) => (
          <Accordion
            key={idx}
            idx={idx + Math.random()}
            title={question.title}
            content={question.description}
          />
        ))}
      </div>
    </section>
  );
}
